<template>
    <v-snackbar
      v-model="$store.getters.snackbar.show"
      top
      right
      :timeout="$store.getters.snackbar.timeout"
    >
      <span>{{ $store.getters.snackbar.text }}</span>
      <!-- <v-btn
        color="pink"
        flat
        @click="closeSnackbar()"
      >
        {{ $t('message.close') }}
      </v-btn> -->
      <v-btn large icon @click="closeSnackbar()">
        <v-icon color="blue darken-2">close</v-icon>
      </v-btn>
    </v-snackbar>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    closeSnackbar () {
      this.$store.dispatch('closeSnackbar')
    }
  }
}
</script>

<style>
  @media only screen and (min-width: 600px) {
    .v-snack__wrapper {
        border-radius: 6px !important;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Base/Snackbar.vue